import TitleUpdater from '../../../../../utils/TitleUpdater';
import ExpertiseTabs from './ExpertiseTabs';
import GenerativeAIFaqs from './GenerativeAIFaqs';
import GenerativeAIHero from './GenerativeAIHero';
import GenerativeAIServices from './GenerativeAIServices';
import IndustrySolutions from './IndustrySolutions';
import TechnologyStacks from './TechnologyStacks';

export default function GenerativeAI() {
  return <main className="font-['Be_Vietnam_Pro']" style={{ background: '#F5F2EE', color: '#171717', overflow: 'hidden' }}>
    <TitleUpdater title="Generative AI Development" />
    <GenerativeAIHero />
    <GenerativeAIServices />
    <ExpertiseTabs />
    <TechnologyStacks />
    <IndustrySolutions />
    <GenerativeAIFaqs />
  </main>;
}
